"use client";
import type { CompactRideRow } from "@/lib/homepageRideModes";
type Props = { rides: CompactRideRow[]; onSelect: (ride: CompactRideRow) => void };
export default function CompactRideList({ rides, onSelect }: Props) {
  return <div aria-label="Available rides list" className="max-h-36 space-y-0.5 overflow-y-auto">
    {rides.map(ride => (
                      <button
                        key={ride.id}
                        type="button"
                        title={`${ride.name}: ${ride.from} → ${ride.to}`}
                        onClick={() => onSelect(ride)}
                        className="flex h-8 w-full min-w-0 items-center gap-1.5 rounded border border-slate-100 bg-slate-50 px-1.5 text-left text-[11px] hover:bg-indigo-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-indigo-600 sm:text-xs"
                      >
                        {ride.photo ? (
                          <img
                            src={ride.photo}
                            alt=""
                            className="h-5 w-5 shrink-0 rounded-full object-cover"
                            referrerPolicy="no-referrer"
                          />
                        ) : (
                          <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-indigo-100 text-[10px] font-bold text-indigo-700">
                            {ride.name.charAt(0).toUpperCase() || "?"}
                          </span>
                        )}

                        <span
                          className="max-w-20 shrink-0 truncate font-semibold text-slate-900"
                          title={ride.name}
                        >
                          {ride.name}
                        </span>

                        <span
                          className="min-w-0 flex-1 truncate text-slate-700"
                          title={`${ride.from} → ${ride.to}`}
                        >
                          {ride.from} → {ride.to}
                        </span>

                        <span
                          className="shrink-0 whitespace-nowrap font-semibold text-indigo-700"
                          title={`${ride.seats} seats available`}
                        >
                          {ride.seats} seat
                        </span>

                        <span className="shrink-0 whitespace-nowrap text-[10px] text-slate-600">
                          {Number.isNaN(Date.parse(ride.dateTime))
                            ? "—"
                            : new Intl.DateTimeFormat("en-IN", {
                                timeZone: "Asia/Kolkata",
                                day: "numeric",
                                month: "short",
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true,
                              }).format(new Date(ride.dateTime))}
                        </span>
                      </button>
    ))}
  </div>;
}
